// RedlineBlock — the agent's summary of what changed versus the prior
// draft / prior period's document. Rendered only when a re-roll produced
// a `redline_vs_prior` note.

interface RedlineBlockProps {
    redline: string;
}

export default function RedlineBlock({ redline }: RedlineBlockProps) {
    return (
        <div
            data-testid="workbench-redline"
            className="rounded-md border border-[rgb(var(--color-rag-amber)/0.4)] bg-[rgb(var(--color-rag-amber)/0.08)] p-3"
        >
            <div className="text-card-title text-[rgb(var(--color-rag-amber))] mb-1">
                Redline vs prior
            </div>
            <div className="text-annotation text-[rgb(var(--color-text-secondary))] whitespace-pre-wrap">
                {redline}
            </div>
        </div>
    );
}
